<template>
  <div class="page page-companies">
    <router-link to="/companies/create" class="btn btn-primary w-100">Добавить</router-link>
    <table class="table table-hover w-100 mt-3 d-none d-md-table">
      <thead>
        <tr>
          <th>Организация</th>
          <th>Исполнительный орган</th>
          <th>Фамилия И.О.</th>
          <th>ИНН</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="company of companies"
          :key="company.id"
          @click="$router.push(`/companies/${company.id}`)"
          class="tablerow"
        >
          <td>{{ company.name }}</td>
          <td>{{ company.position }}</td>
          <td>{{ company.sign_name }}</td>
          <td>{{ company.inn }}</td>
        </tr>
      </tbody>
    </table>
    <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="company of companies" :key="company.id">
      <table v-if="companies.length > 0" class="table borderless">
        <tbody>
          <tr>
            <td style="border-top: none">Организация</td>
            <td style="border-top: none">{{ company.name }}</td>
          </tr>
          <tr>
            <td>Исполнительный орган</td>
            <td>{{ company.position }}</td>
          </tr>
          <tr>
            <td>Фамилия И.О.</td>
            <td>{{ company.sign_name }}</td>
          </tr>
          <tr>
            <td>ИНН</td>
            <td>{{ company.inn }}</td>
          </tr>
        </tbody>
      </table>
      <router-link
        :to="{ name: 'companyPage', params: { id: company.id } }"
        class="btn btn-primary btn-md create-car ml-auto"
        >Подробно</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Companies',
  mounted () {
    this.loadItems()
  },
  computed: {
    ...mapState('taxi/companies', {
      companies: state => state.items,
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading
    })
  },
  beforeDestroy () {
    this.abortLoading()
  },
  methods: {
    ...mapActions('taxi/companies', [
      'loadItems',
      'abortLoading'
    ])
  }
}
</script>
<style scoped>
  @media screen and (max-width: 1199px) {
    .page {
      padding: 1rem;
    }
  }
  @media screen and (max-width: 576px) {
    .page {
      padding: 0.5rem;
    }
  }
  .tablerow {
    cursor: pointer;
  }
</style>
